import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

interface MenuItem {
  path: string;
  label: string;
  icon: string;
}

const menuItems: MenuItem[] = [
  { path: '/', label: 'Inici', icon: '🏠' },
  { path: '/cicles', label: 'Cicles Formatius', icon: '📚' },
  { path: '/moduls', label: 'Mòduls Professionals', icon: '📖' },
  { path: '/usuaris', label: 'Usuaris', icon: 'U' },
];

function Menu() {
  const { usuari, logout, teRol } = useAuth();
  const navigate = useNavigate();
  const visibleItems = menuItems.filter((item) => item.path !== '/usuaris' || teRol('ADMINISTRADOR'));

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <nav className="menu">
      <div className="menu-header">
        <h2>AVALUAM</h2>
        <span>Plataforma Educativa</span>
      </div>
      <div className="menu-nav">
        {visibleItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `menu-item${isActive ? ' active' : ''}`
            }
          >
            <span className="menu-item-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </div>
      <div className="menu-session">
        <div>
          <strong>{usuari ? `${usuari.nom} ${usuari.cognoms}` : 'Sessió activa'}</strong>
          <span>{usuari?.email}</span>
        </div>
        <button type="button" onClick={handleLogout}>
          Sortir
        </button>
      </div>
    </nav>
  );
}

export default Menu;
